// Route path literals shared by everything that has to *navigate* somewhere.
//
// Two reasons this is its own module rather than constants hanging off the views
// that own each route:
//
//  1. Drift. `/albums` was previously written out three separate times — in
//     app/Router.tsx, templates/SideMenuTemplate and views/CallbackView — with
//     nothing tying them together, which is exactly the class of problem
//     views/FrDiagnosticsView/constants.ts was created to stop for its own route.
//  2. Cycles. `PageTemplate -> PrimaryNavigation -> SideMenuTemplate` already
//     forms an import cycle, so SideMenuTemplate cannot import from a view. The
//     consumers here span app/, views/, templates/ and stores/, so this module
//     is a dependency-free leaf: it must import nothing from views/, templates/,
//     stores/ or components/.
//
// Deliberately NOT moved here: FR_DIAGNOSTICS_PATH and TAGGED_PHOTO_REPORT_PATH.
// They already solve this problem for their own routes and are paired with the
// ConfigCat flag key for the same feature, so relocating them would be churn
// with no defect behind it. The inconsistency is a decision, not an oversight.
//
// react-router-dom@5.3.3 has no relative routing, so every value here is a full
// absolute path rather than a composable segment.

export const ALBUMS_PATH = '/albums'

// The album *detail* route is `/album/:id`. Only the static prefix lives here —
// route patterns and route destinations are different concerns, and threading
// `:id` through a constant makes Router.tsx harder to read, not easier.
export const ALBUM_DETAIL_PREFIX = '/album'

export const MICROPOSTS_PATH = '/microposts'
export const HOME_PATH = '/home'

export const LOGIN_PATH = '/login'
export const CALLBACK_PATH = '/callback'
export const LOGOUT_PATH = '/logout'
export const AUTH_ERROR_PATH = '/auth-error'
export const PRIVACY_POLICY_PATH = '/privacy-policy'
export const TERMS_OF_SERVICE_PATH = '/terms-of-service'
